// Forward-geocodes a free-text query DIRECTLY against the Mapbox Places API
// (not via our backend) — used for address autocomplete in AddressInput.
// SECURITY: uses the public browser token REACT_APP_MAPBOX_ACCESS_TOKEN,
// which is visible in the bundle by design; keep it URL-restricted in the
// Mapbox dashboard and never put the backend's GEOCODE_MAPBOX_KEY here.
export default async function getPlaces(query) {
  try {
    const response = await fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json?access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`
    );

    return response.json();
  } catch (error) {
    console.error("There was an error while fetching places:", error);
    throw new Error("getPlaces(query) failed");
  }
}
